// Helper condiviso per nascondere nelle pagine i bottoni crea/modifica/elimina che il
// ruolo dell'utente non può comunque usare (il backend blocca già il salvataggio via
// requirePermission — questo evita solo di mostrare un controllo che fallirebbe sempre).
// ROOT bypassa sempre, non ha mai una mappa permessi.
export const puoFare = (user, modulo, azione) =>
  user?.ruolo === 'ROOT' || !!user?.permessi?.[modulo]?.[azione];
